export const checkProcessEnv =() => {
  return process.env.VUE_APP_DELETE_PERMISSIONS==='true'
}
export const debounce=(fn, time)=> {
  time = time || 200
  // 定时器
  let timer = null
  return function(...args) {
    var _this = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(_this, args)
    }, time)
  }
  
};
//节流
export const throttle = (fn, time)=> {
  let timer = null
  time = time || 1000
  return function(...args) {
    if (timer) {
      return
    }
    const _this = this
    timer = setTimeout(() => {
      timer = null
    }, time)
    fn.apply(_this, args)
  }
}
// 判断正、负
export const strIncrease = (str)=>{
  if(str.slice(0,1) ==='-'){
    return true
    }
}
 // 获取最大值方法
 export const calMax=(arr)=> {
  var max = Math.max.apply(null, arr) // 获取最大值方法
  var maxint = Math.ceil(max / 5) // 向上以5的倍数取整
  var maxval = maxint * 5 + 5 // 最终设置的最大值
  return maxval // 输出最大值
}
// 获取最小值方法
export const calMin=(arr)=> {
  var min = Math.min.apply(null, arr) // 获取最小值方法
  var minint = Math.floor(min / 1) // 向下以1的倍数取整
  var minval = minint * 1 // 最终设置的最小值
  return minval // 输出最小值
}
